import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    value: {
        header: {},
        lines: [],
    },
}

export const baselineSlice: any = createSlice({
    name: 'BASELINE',
    initialState,
    reducers: {
        setBaseline: (state: any, action: any) => {
            state.value = action.payload
        },
    },
})

export const { setBaseline } = baselineSlice.actions

export default baselineSlice.reducer
